import { Timer } from './Timer';

import { useTimeControl } from './useTimeControl';
import { useCallback } from 'react';
import type { ViewModelEntity } from '@view-model/domain/view-model';
import type { Workspace } from '@workspace/domain/workspace';
type Props = {
  showTimer: boolean;
  onOpen(): void;
  onClose(): void;
  viewModel: ViewModelEntity;
  workspace: Workspace;
};

export const TimerContainer: React.FC<Props> = ({ showTimer, onOpen, onClose, viewModel, workspace }: Props) => {
  const {
    totalSeconds,
    isExpired,
    isRunning,
    canEditTimer,
    handleControlTimer,
    handleResetTimer,
    handleIncreaseTime,
    handleDecreaseTime,
    handleUpdateTime,
    handleResetExpiredState,
  } = useTimeControl(viewModel, workspace, onOpen);

  const handleClose = useCallback(() => {
    onClose();
    if (isExpired) {
      handleResetExpiredState();
    }
  }, [onClose, handleResetExpiredState, isExpired]);

  if (!showTimer) return null;

  return (
    <div className="pointer-events-auto absolute right-8 top-20">
      <Timer
        totalSeconds={totalSeconds}
        isRunning={isRunning}
        onControlTimer={handleControlTimer}
        onResetTimer={handleResetTimer}
        onIncreaseTime={handleIncreaseTime}
        onDecreaseTime={handleDecreaseTime}
        onUpdateTime={handleUpdateTime}
        onClose={handleClose}
        isExpired={isExpired}
        canEditTimer={canEditTimer}
      />
    </div>
  );
};
